<template>
    <div class="orders-gallery">
        <OrderModalWebcam
            :is-active-data="modals.webcam.isActive"
            @close-handle="webcamModalClose"
            @on-capture="onCaptureHandle"
        />
        <div
            v-if="
                getAllowed(['ADMIN', 'manager', 'usa_manager']) &&
                state !== 'Archived'
            "
            class="orders-gallery__header"
        >
            <div class="orders-gallery__actions">
                <input
                    ref="input"
                    class="orders-gallery__file-input"
                    type="file"
                    multiple
                    @input="changeFilesHandle"
                />
                <v-btn
                    color="#967adc"
                    dark
                    :x-small="!isMobile"
                    :small="isMobile"
                    @click="openUpload"
                >
                    {{ $t('pages.wigPage.gallery.uploadFile') }}
                </v-btn>
                <v-btn
                    color="#967adc"
                    dark
                    :x-small="!isMobile"
                    :small="isMobile"
                    @click="webcamModalOpen"
                >
                    {{ textContent['take-a-photo'] }}
                </v-btn>
            </div>
        </div>

        <div v-if="files.images.length > 0">
            <div class="orders-gallery__files-title">
                {{ $t('pages.wigPage.gallery.photos') }}:
            </div>
            <OrdersGalleryFilesList :files="files.images" :state="state" />
        </div>

        <div v-if="files.video.length > 0">
            <div class="orders-gallery__files-title">
                {{ $t('pages.wigPage.gallery.videos') }}:
            </div>
            <OrdersGalleryFilesList
                :files="files.video"
                :state="state"
                :is-video="true"
            />
        </div>
    </div>
</template>

<script>
import OrderModalWebcam from '@/components/modals/order-modal-webcam'

import { mapActions } from 'vuex'
import { actionTypes } from '@/store/modules/orders'
import { actionTypes as actionTypesModalNotifications } from '@/store/modules/modal-notifications'
import { actionTypes as actionTypesConfirmer } from '@/store/modules/confirmer'
import languageMixin from '@/mixins/language.mixin'
import convertBase64ToFile from '@/helpers/convert-base64-to-file'
import formatDate from '@/helpers/format-date'
import OrdersGalleryFilesList from '@/components/orders/orders-gallery-files-list.vue'
import { SUPPORTED_VIDEO_FORMATS, SUPPORTED_IMAGE_FORMATS } from '@/consts'

export default {
    name: 'OrdersGallery',
    components: {
        OrdersGalleryFilesList,
        OrderModalWebcam,
    },
    mixins: [languageMixin],
    props: {
        files: {
            type: Object,
            default: () => ({
                video: [],
                images: [],
            }),
        },
        state: {
            type: String,
            default: 'Draft',
        },
    },
    data() {
        return {
            newFiles: [],
            modals: {
                webcam: {
                    isActive: false,
                },
            },
        }
    },
    computed: {
        isMobile: function () {
            return this.$resize && !this.$mq.above(1023)
        },
    },
    methods: {
        ...mapActions('orders', {
            addNewPhoto: actionTypes.addNewPhoto,
            deletePhoto: actionTypes.deletePhoto,
        }),
        ...mapActions('modalNotifications', {
            success: actionTypesModalNotifications.success,
            error: actionTypesModalNotifications.error,
        }),
        ...mapActions('confirmer', {
            confrimHandle: actionTypesConfirmer.confirmHandle,
        }),
        webcamModalOpen: function () {
            this.modals.webcam.isActive = true
        },
        webcamModalClose: function () {
            this.modals.webcam.isActive = false
        },
        changeFilesHandle: async function (e) {
            const files = e?.target?.files

            if (!files) return

            const filesObj = {
                images: [],
                videos: [],
            }

            try {
                Object.values(files).forEach((item) => {
                    if (
                        !SUPPORTED_VIDEO_FORMATS.includes(item.type) &&
                        !SUPPORTED_IMAGE_FORMATS.includes(item.type)
                    ) {
                        throw new Error(`Unsupported file format: ${item.type}`)
                    }

                    if (SUPPORTED_VIDEO_FORMATS.includes(item.type)) {
                        filesObj.videos.push(item)
                    }

                    if (SUPPORTED_IMAGE_FORMATS.includes(item.type)) {
                        filesObj.images.push(item)
                    }
                })

                await this.addNewPhoto(filesObj)
                await this.success(this.$t('pages.wigPage.gallery.fileAdded'))
            } catch (error) {
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    'Something went wrong'

                await this.error(errorMessage)
            }
        },
        openUpload: function () {
            this.$refs.input.value = ''
            this.$refs.input.click()
        },
        onCaptureHandle: function (file) {
            const filesObj = {
                images: [],
                videos: [],
            }
            filesObj.images.push(convertBase64ToFile(file))

            this.webcamModalClose()
            this.addNewPhoto(filesObj).then(() => {
                this.success(this.textContent['photo-success-added'])
            })
        },
        dateInFormat: function (date) {
            return formatDate(date)
        },
    },
}
</script>

<style lang="scss" scoped>
.orders-gallery {
    padding: 16px;
    border-radius: 4px;
    background: #f7f7f9;
    max-width: 100%;
    margin-top: 16px;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: -16px;
        left: 0;
        height: 1px;
        width: 100%;
        background: linear-gradient(to right, transparent 50%, #fff 50%),
            linear-gradient(to right, #b2b2b2, #b2b2b2);
        background-size: 4px 2px, 100% 2px;
    }

    &__header {
    }

    &__actions {
        display: flex;
        justify-content: space-between;

        button + button {
            margin-left: 10px;
        }

        margin-bottom: 25px;
    }

    &__files-title {
        margin: 20px 0;
    }

    &__file-input {
        display: none;
    }
}
</style>
